import { Container, Row } from 'react-bootstrap'
import { useActiveWeb3React } from '../../hooks'
import config from '../../config.json'
import StakeCard from '../StakeCard'

function Main(): JSX.Element {
  const { chainId } = useActiveWeb3React()
  const networkId = chainId ?? Number(process.env.REACT_APP_CHAIN_ID)

  const pools = config.pools[networkId]

  return (
    <Container>
      <Row className="justify-content-center mt-5">
        {pools.length > 0 && (
          <>
            {pools.map(p => {
              return <StakeCard key={p.id} poolId={p.id} />
            })}
          </>
        )}
      </Row>
    </Container>
  )
}

export default Main
